import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '$src/store';
import {makeRoute} from '$src/lib/helper';


Vue.use(VueRouter);

let router = new VueRouter({
    mode: 'history',
    linkActiveClass: 'active',
    routes: [
        makeRoute('/not-authorized', 'not_authorized', require('$src/views/NotAuthorizedView').default, {
            title: 'Fehler',
        }),
        makeRoute('/not-found', 'not_found', require('$src/views/Error404View').default, {
            title: 'Fehler',
        }),
        {
            path: '*',
            meta: {title: 'Fehler'},
            component: require('$src/views/Error404View').default,
        },
    ],
});
export default router;

export function registerAuthGuard() {
    router.beforeEach(async (to, from, next) => {
        Vue.$ui.scrollTo(1, 0);

        let user = store.getters['auth/getUser'];
        let {
            isAuth = null,
            isGuest = null,
            hasRole = null,
            hasRight = null,
        } =  mergeRouteMeta(to);

        if (isAuth === true && user === null) {
            return next({name: 'landing_login', params: {origin_to: to}});
        }

        if ((isGuest === true && !store.getters['auth/isGuest'])) {
            if (Vue.$env.isCommunity) {
                if (to.name === 'landing_login' && to.query.force === "true") {
                    return next();
                }
                return next({name: 'community_home'});
            }

            if (Vue.$is('applicant')) {
                return next({name: 'application_overview', params: {id_user: user.id_user}});
            }

            return next({name: 'backend_home'});
        }

        if (
            (hasRole !== null && !Vue.$is(hasRole)) ||
            (hasRight !== null && !Vue.$can(hasRight))
        ) {
            return next({name: 'not_authorized'});
        }

        next();
    });
}

export function registerActionGuard() {
    router.beforeEach(async (to, from, next) => {
        let {action = null} = mergeRouteMeta(to);

        if (action !== null) {
            Vue.$loading('global', true);
            await store.dispatch(action, to.params);
            Vue.$loading('global', false);
        }

        next();
    });
}

export function mergeRouteMeta(route) {
    return route.matched.reduce((result, route) => ({...result, ...route.meta}), {});
}